import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M31.78,17.18a.66.66,0,0,0-.46-.19H28l-2.49-6.17a.65.65,0,0,0-.61-.41h-5V6.69A.65.65,0,0,0,19.28,6H4a.65.65,0,0,0-.65.65v15.9L0,24.26l.59,1.16,3.26-1.67.07,0H7.76a2.83,2.83,0,0,0,5.52,0H22a2.83,2.83,0,0,0,5.51,0h3.81a.65.65,0,0,0,.65-.65V17.64A.66.66,0,0,0,31.78,17.18ZM10.52,24.66a1.54,1.54,0,1,1,1.54-1.54A1.54,1.54,0,0,1,10.52,24.66Zm0-4.38a2.84,2.84,0,0,0-2.76,2.19H4.6V7.34h14V22.47H13.28A2.84,2.84,0,0,0,10.52,20.28Zm14.23,4.38a1.54,1.54,0,1,1,1.54-1.54A1.54,1.54,0,0,1,24.75,24.66Zm5.92-2.19H27.51a2.83,2.83,0,0,0-5.51,0H19.93V11.72h4.54L27,17.89a.65.65,0,0,0,.6.41h3.11Z' })
));